import { MetaPixelEvent, EventParams } from '../types/analytics';

const isMetaPixelLoaded = (): boolean => {
  return typeof window !== 'undefined' && typeof window.fbq === 'function';
};

const isGoogleAnalyticsLoaded = (): boolean => {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

export const trackPageView = (): void => {
  if (isMetaPixelLoaded()) {
    window.fbq!('track', 'PageView');
  }

  if (isGoogleAnalyticsLoaded()) {
    window.gtag!('event', 'page_view', {
      page_location: window.location.href,
      page_path: window.location.pathname,
    });
  }
};

export const trackEvent = (eventName: MetaPixelEvent, params?: EventParams): void => {
  if (isMetaPixelLoaded()) {
    window.fbq!('track', eventName, params);
  }
};

export const trackCustomEvent = (eventName: string, params?: EventParams): void => {
  if (isMetaPixelLoaded()) {
    window.fbq!('trackCustom', eventName, params);
  }
};

export const trackCompleteRegistration = (params?: EventParams): void => {
  trackEvent('CompleteRegistration', params);
};

export const trackLead = (params?: EventParams): void => {
  trackEvent('Lead', params);
};

export const trackSearch = (searchString: string, params?: EventParams): void => {
  trackEvent('Search', {
    ...params,
    search_string: searchString,
  });
};

export const trackViewContent = (contentName: string, contentId?: string, params?: EventParams): void => {
  trackEvent('ViewContent', {
    ...params,
    content_name: contentName,
    content_ids: contentId ? [contentId] : undefined,
  });
};

export const trackInitiateCheckout = (params?: EventParams): void => {
  trackEvent('InitiateCheckout', params);
};

export const trackBookingStarted = (params?: {
  provider_id?: string;
  provider_name?: string;
  service_type?: string;
  [key: string]: unknown;
}): void => {
  if (isGoogleAnalyticsLoaded()) {
    window.gtag!('event', 'booking_started', params);
  }

  if (isMetaPixelLoaded()) {
    window.fbq!('trackCustom', 'BookingStarted', params as EventParams);
  }
};

export const trackBookingCompleted = (params?: {
  provider_id?: string;
  provider_name?: string;
  service_type?: string;
  appointment_date?: string;
  booking_id?: string;
  value?: number;
  currency?: string;
  [key: string]: unknown;
}): void => {
  if (isGoogleAnalyticsLoaded()) {
    window.gtag!('event', 'booking_completed', params);
  }

  if (isMetaPixelLoaded()) {
    window.fbq!('trackCustom', 'BookingCompleted', params as EventParams);
  }
};

export const trackProviderViewed = (params?: {
  provider_id?: string;
  provider_name?: string;
  type_of_care?: string;
  location?: string;
  [key: string]: unknown;
}): void => {
  if (isGoogleAnalyticsLoaded()) {
    window.gtag!('event', 'provider_viewed', params);
  }

  if (isMetaPixelLoaded()) {
    window.fbq!('trackCustom', 'ProviderViewed', params as EventParams);
  }
};

export const trackOtpVerified = (params?: {
  email?: string;
  verification_method?: string;
  [key: string]: unknown;
}): void => {
  if (isGoogleAnalyticsLoaded()) {
    window.gtag!('event', 'otp_verified', params);
  }

  if (isMetaPixelLoaded()) {
    window.fbq!('trackCustom', 'OtpVerified', params as EventParams);
  }
};

export const analytics = {
  trackPageView,
  trackEvent,
  trackCustomEvent,
  trackCompleteRegistration,
  trackLead,
  trackSearch,
  trackViewContent,
  trackInitiateCheckout,
  trackBookingStarted,
  trackBookingCompleted,
  trackProviderViewed,
  trackOtpVerified,
};

export default analytics;
